import * as routingHistory from './lib/modules/routing-history';

export default routingHistory;
